import { toaster } from "@/utilities/toaster";
import { Guid } from "guid-typescript";
import { assign, Machine } from "xstate";
import { FormModule } from "../../../../../store/modules/paForm.module";
const formMachine = Machine({
    id: "formMachine",
    context: {
        mode: "",
        formId: Guid.createEmpty(),
    },
    initial: "idle",
    states: {
        idle: {
            always: { target: "modalDormant" },
        },
        modalDormant: {
            on: {
                SHOW_FORM: { target: "checkingFormMode", actions: ["assignMode", "assignFormId"] },
            },
        },
        checkingFormMode: {
            always: [
                {
                    target: "loadedForm",
                    cond: (cxt, evt) => cxt.mode === "Add",
                },
                {
                    target: "gettingForm",
                    cond: (cxt, evt) => cxt.mode === "Edit" || cxt.mode === "View",
                },
            ],
        },
        gettingForm: {
            invoke: {
                id: "gettingForm",
                src: (cxt, evt) => {
                    return FormModule.GetFormsById(cxt.formId);
                },
                onDone: { target: "loadedForm" },
                onError: { target: "loadedForm" },
            },
        },
        loadedForm: {
            on: {
                ADDING_FORM: { target: "savingForm" },
                ADD_QUESTION: { target: "addingQuestion" },
                CANCEL_FORM: { target: "modalDormant" },
                EDITING_FORM: { target: "updatingForm" },
            },
        },
        addingQuestion: {
            tags: "addQuestion",
            on: {
                DELETE_QUESTION: { target: "deletingQuestion" },
                ADDING_FORM: { target: "savingForm" },
                ADD_QUESTION: { target: "addingQuestion" },
                CANCEL_FORM: { target: "modalDormant" },
                EDITING_FORM: { target: "updatingForm" },
            },
        },
        savingForm: {
            invoke: {
                id: "savingForm",
                src: (cxt, evt) => {
                    return FormModule.SaveForm(evt.item);
                },
                onDone: { target: "modalDormant", actions: "formSaveDone" },
                onError: { target: "loadedForm" },
            },
        },
        updatingForm: {
            invoke: {
                id: "updatingForm",
                src: (cxt, evt) => {
                    return FormModule.EditForm(evt.item);
                },
                onDone: { target: "modalDormant", actions: "formUpdateDone" },
                onError: { target: "loadedForm" },
            },
        },
        deletingQuestion: {
            always: { target: "loadedForm" },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignMode: assign({
            mode: (context, event) => event.mode,
        }),
        assignFormId: assign({
            formId: (context, event) => event.formId,
        }),
        formSaveDone: (context, event) => {
            toaster.ShowSuccess("A Form has been created successfully.");
        },
        formUpdateDone: (context, event) => {
            toaster.ShowSuccess("A Form has been updated successfully.");
        },
    },
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default formMachine;
